var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./WaitingForDeliveryAddGoodsPage.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-59d5bf3a!../../node_modules/vue-loader/lib/selector?type=template&index=0!./WaitingForDeliveryAddGoodsPage.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/WaitingForDeliveryAddGoodsPage.vue
// module id = 309
// module chunks = 1